<template>
  <div>
    <div class="header" />
    <div class="container">
      <div class="columns gutter">
        <div class="column is-9">
          <h1 class="title is-1 text color-white">
            FAQ
          </h1>

          <div class="margin-bottom-xl" />

          <div class="box is-large text">
            <faq-list />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FAQList from '@/components/FAQList.vue'

export default {
  components: {
    'faq-list': FAQList
  },

  metaInfo: {
    title: 'FAQ | Music Licensing'
  }
}
</script>

<style lang="sass" scoped>

</style>
